import { Button } from "react-bootstrap"

export const TeacherCoreIdeasViewButton: React.FC<{onClick: () => void}> = ({ onClick }) => {
    return (
        <Button
            key="view-core-ideas-btn"
            className="ms-2"
            onClick={onClick}
            variant="theme">
                <i className="fa-solid fa-chess-board pe-2" />
                <span className="d-none d-md-inline">View Assigned Core Ideas</span>
        </Button>
    )
}
